import HeroSection from "../components/HeroSection";
import StatsBar from "../components/StatsBar";
import DifferenceSection from "../components/DifferenceSection";
import ProcessSection from "../components/ProcessSection";
import HomeCTA from "../components/HomeCTA";

export default function HomePage({ onOpenModal }) {
  return (
    <>
      <HeroSection onOpenModal={onOpenModal} />
      <StatsBar />
      <DifferenceSection />
      <ProcessSection />
      <HomeCTA onOpenModal={onOpenModal} />
    </>
  );
}
